module.exports = __webpack_public_path__ + "static/media/GAMES.f88aab22.svg";